// 油品调整
import { request,pretty } from '@/utils/request' 
export const addPrompt = (item)=>{
  return pretty(request.post("/api/Prompt/Add",{...item}));
}
export const deletePrompt = (item)=>{
  return pretty(request.post(`/api/Prompt/Delete?ids=${item}`));
}
export const detailPrompt = (item)=>{
  return pretty(request.get(`/api/Prompt/Detail?id=${item}`));
}
export const editPrompt = (item)=>{
  return pretty(request.post("/api/Prompt/Edit",{...item}));
}
export const listPrompt = (item)=>{
  return pretty(request.get(`/api/Prompt/List?title=${item?.title?(item?.title):''}&pageSize=${item?.pageSize?(item?.pageSize):10}&pageIndex=${item?.pageIndex?(item?.pageIndex):1}`));
}